// Thin fetch wrapper for the Algonest API. On Azure Static Web Apps the API is
// served same-origin under /api, so no CORS or base URL config is needed. For
// local dev you can point at a running API with REACT_APP_API_BASE.
const BASE = process.env.REACT_APP_API_BASE || "/api";

async function request(method, path, body, token) {
  const headers = { "Content-Type": "application/json" };
  // Azure Static Web Apps strips the standard Authorization header before it
  // reaches managed functions, so we send the JWT in a custom header (which SWA
  // forwards). Authorization is kept too for local dev (swa start / direct API).
  if (token) {
    headers["x-algonest-token"] = token;
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body != null ? JSON.stringify(body) : undefined,
  });

  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    /* empty / non-JSON body */
  }

  if (!res.ok) {
    const err = new Error((data && data.error) || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const apiPost = (path, body, token) => request("POST", path, body, token);
export const apiGet = (path, token) => request("GET", path, null, token);
export const apiPut = (path, body, token) => request("PUT", path, body, token);
